import { render, staticRenderFns } from "./PropostaCreate.vue?vue&type=template&id=73e57d9a&scoped=true"
import script from "./PropostaCreate.vue?vue&type=script&lang=js"
export * from "./PropostaCreate.vue?vue&type=script&lang=js"
import style0 from "./PropostaCreate.vue?vue&type=style&index=0&id=73e57d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e57d9a",
  null
  
)

export default component.exports